export default __webpack_public_path__ + "1304ec96f3eceffc44a9fb8838fe6568.png";